import Fresco71 from "./fresco7.webp";

const Fresco7 = [Fresco71];

export default Fresco7;
